import {
  createContext,
  useContext,
  useEffect,
  useId,
  type ReactNode,
} from "react";
export const DirtyContext = createContext<(id: string, dirty: boolean) => void>(
  () => {},
);
export function useDirty(dirty: boolean) {
  const id = useId();
  const report = useContext(DirtyContext);
  useEffect(() => {
    report(id, dirty);
    return () => report(id, false);
  }, [id, dirty, report]);
}
